import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-direction-btn-cell-renderer',
    templateUrl: './direction-btn-cell-renderer.component.html',
    standalone: false
})
export class DirectionBtnCellRendererComponent implements ICellRendererAngularComp {
  public cellValue: string = '';
  hearingRooms: string[] = ['A1', 'A2', 'B1', 'B2', 'Gardner Auditorium', 'House Chamber', 'House Gallery', '428', 'Senate Chamber', 'Senate Gallery']; //available hearing rooms to navigate to from the DirectionSettings.json & WayfinderMothership

  constructor(
    protected router: Router,
    protected toastr: ToastrService
  ) { }

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getDirection(location: string) {
    let cleanedLocation = location.trim().replace(/and Virtual/g, '').replace(/-/g, '').toLowerCase();
    cleanedLocation = cleanedLocation.replace(/-/g, '');
    cleanedLocation = cleanedLocation.replace(/&/g, '');

    const matchingRoom = this.hearingRooms.find(room => {
      const cleanedRoom = room.toLowerCase();
      if (cleanedRoom.includes(cleanedLocation)) {
        return true;
      }
      if (cleanedLocation.includes(cleanedRoom)) {
        return true;
      }
      return false;
    });

    if (matchingRoom) {
      this.router.navigate(['directions/', matchingRoom.trim(), '']);
    } else {
      this.toastr.warning('Direction is not yet available for this specific location'); //TBD MassLeg api WayfinderMothership need to be updated to add more directions
    }
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.data.location;
  }
}
